import useStyles from './styles';
import React, { useEffect } from 'react';
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Navigate } from 'react-router-dom';
import { BackdropLoader } from '@livable/saas-react-components';
import { useStore } from 'src/stores';
import { BillsTab } from './BillsTab';
import { BillIntakeAliasBanner } from './BillIntakeAliasBanner';
export const BillsPage = observer(() => {
  const classes = useStyles();
  const store = useStore();

  // The sidebar entry is gated on this flag, but the route was not, so /bills and the
  // /bills?billId= deep link stayed reachable by URL for any logged-in user. Treated as a route
  // that does not exist rather than a refusal message, because the flag being off means the
  // feature is not released yet and should not advertise itself.
  //
  // Safe to read during render: index.tsx awaits getFeatureFlagsAsync before mounting the app, and
  // every flag in the store model defaults to false, so an unfetched flag fails closed.
  const isBillsEnabled = store.account.featureFlagsStore.getIsBillsDashboardEnabled;
  useEffect(() => {
    if (!isBillsEnabled) return;
    const loadCompanyProperties = async () => {
      // The allocation suggestions match a bill's services against the utility types on a property.
      await store.company.getCompanyPropertiesAsync.run({
        withUtilityTypes: true
      }, []);
    };
    loadCompanyProperties();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBillsEnabled]);
  const isLoading = store.company.getCompanyPropertiesAsync.inProgress;
  if (!isBillsEnabled) {
    return /*#__PURE__*/React.createElement(Navigate, {
      replace: true,
      to: "/error_page"
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapper
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.pageHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, "Bills")), /*#__PURE__*/React.createElement("div", {
    className: classes.contentWrapper
  }, /*#__PURE__*/React.createElement(BillIntakeAliasBanner, null), /*#__PURE__*/React.createElement(BillsTab, null)));
});